<template>
  <img
    :class="computedClasses"
    :loading="loading"
  >
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  fluid?: boolean
  rounded?: boolean
  roundedTop?: boolean
  center?: boolean
  loading?: 'eager' | 'lazy'
  card?: boolean
  preserveAspect?: boolean
}>(), {
  loading: 'lazy',
})

const computedClasses = computed(() => [
  {
    'max-w-full h-auto': props.fluid,
    'rounded-sm': props.rounded,
    'block mx-auto': props.center,
    'shrink-0 w-full': props.card,
    'rounded-t-sm': props.roundedTop,
    'object-cover object-center': props.preserveAspect,
  },
])
</script>
